export const BASE = {
  name: 'settings',
  path: '/settings',
};

export const ACCOUNT = {
  name: 'settings.account',
  path: `${BASE.path}/account`,
};

export const INVOICES = {
  name: 'settings.invoices',
  path: `${BASE.path}/invoices`,
};

export const INVOICES_OWNER = {
  name: 'settings.invoices.owner',
};

export const INTEGRATIONS = {
  name: 'settings.integrations',
  path: `${BASE.path}/integrations`,
};

export const INTEGRATION_DETAILS = {
  name: 'settings.integrations.details',
  path: `${INTEGRATIONS.path}/sites/:siteId/:integrationName`,
};

export const INTEGRATIONS_HUBSPOT_OAUTH_REDIRECT = {
  name: 'settings.integrations.hubspot_oauth_redirect',
  path: `${INTEGRATIONS.path}/hubspot-redirect`,
};

export const BILLING = {
  name: 'settings.billing',
  path: `${BASE.path}/billing?pb-context`,
};

export const BILLING_V2 = {
  name: 'settings.billing.v2',
};

export const SUBSCRIPTIONS = {
  name: 'settings.subscriptions',
  path: `${BASE.path}/subscriptions`,
};

export const PAYMENT_DETAILS = {
  name: 'settings.payment_details',
  path: `${BASE.path}/payment-details`,
};

export const USER_LOOKUP = {
  name: 'settings.visitorLookup',
  path: `${BASE.path}/user-lookup`,
};

export const BILLING_NO_ACCESS = {
  name: 'settings.billing.no_access',
};

export const INVOICES_NO_ACCESS = {
  name: 'settings.invoices.no_access',
};

export const USER_ATTRIBUTES = {
  name: 'settings.userAttributes',
  path: `${BASE.path}/user-attributes`,
};

export const SSO = {
  name: 'settings.sso',
  path: `${BASE.path}/sso`,
};

export const PUBLIC_API = {
  name: 'settings.list',
  path: `${BASE.path}/api`,
};
